import { render, staticRenderFns } from "./AddExchangeAggregatorUser.vue?vue&type=template&id=e3f67a74&scoped=true&lang=pug"
import script from "./AddExchangeAggregatorUser.vue?vue&type=script&lang=js"
export * from "./AddExchangeAggregatorUser.vue?vue&type=script&lang=js"
import style0 from "./AddExchangeAggregatorUser.vue?vue&type=style&index=0&id=e3f67a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f67a74",
  null
  
)

export default component.exports